import { render, staticRenderFns } from "./clinic_form.vue?vue&type=template&id=a0f1c23a&scoped=true&"
import script from "./clinic_form.vue?vue&type=script&lang=js&"
export * from "./clinic_form.vue?vue&type=script&lang=js&"
import style0 from "./clinic_form.vue?vue&type=style&index=0&id=a0f1c23a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f1c23a",
  null
  
)

export default component.exports